{
  "wizard": {
    "createCharacter": "Create Character",
    "back": "Back",
    "next": "Next",
    "createCharacterAction": "Create Character",
    "complete": "Complete",
    "required": "Required",
    "noOptionsAvailable": "No options available",
    "identity": {
      "name": "Name",
      "namePlaceholder": "Enter character name...",
      "race": "Race",
      "selectRace": "Select a race...",
      "abilityBonuses": "Ability Score Bonuses",
      "abilityBonusesDesc": "Choose {{count}} ability score{{plural}} to increase by +1",
      "extraLanguage": "Extra Language",
      "extraLanguageDesc": "Choose {{count}} additional language{{plural}}",
      "subrace": "Subrace",
      "selectSubrace": "Select a subrace...",
      "background": "Background",
      "selectBackground": "Select a background...",
      "additionalLanguages": "Additional Languages",
      "additionalLanguagesDesc": "Your background grants {{count}} additional language{{plural}} of your choice.",
      "backgroundTraits": "Background Traits",
      "backgroundTraitsDesc": "Select or roll your character's personality traits, ideal, bond, and flaw.",
      "rollAll": "Roll All",
      "personalityTraits": "Personality Traits",
      "ideal": "Ideal",
      "bond": "Bond",
      "flaw": "Flaw",
      "roll": "Roll",
      "racialTraits": "Racial Traits:",
      "subraceTraits": "Subrace Traits:",
      "skills": "Skills:",
      "equipment": "Equipment:"
    },
    "class": {
      "addClass": "Add Class",
      "maxLevelReached": "Maximum level (20) reached",
      "allClassesSelected": "All classes selected",
      "noClassesSelected": "No classes selected. Add at least one class to continue.",
      "totalLevel": "Total Level",
      "removeClass": "Remove {{className}}",
      "hitDie": "d{{hitDie}} Hit Die",
      "savingThrow": "Save: {{ability}}",
      "skillProficiencies": "Skill Proficiencies",
      "level1Features": "Level 1 Features",
      "selectSubclass": "Select subclass...",
      "subclass": "Subclass",
      "featureChoices": "Feature Choices",
      "multiclassWarning": "Multiclass Prerequisites Not Met",
      "multiclassAbilityWarning": "{{ability}}: {{current}}/{{required}}",
      "spellcasting": "Spellcasting",
      "cantripsStatus": "Cantrips: {{count}}/{{max}}",
      "spellsStatus": "Spells: {{count}}/{{max}}",
      "cantrips": "Cantrips",
      "firstLevelSpells": "1st Level Spells",
      "spellsByLevel": "Spells (1st-{{maxLevel}} Level)",
      "preparedSpellsDesc": "As a {{className}}, you prepare spells each day from the full {{classNameLower}} spell list. The number of spells you can prepare equals your spellcasting ability modifier + your class level.",
      "spellSlots": "Spell Slots:",
      "noSpellsFound": "No spells found",
      "searchPlaceholder": "Search {{title}}...",
      "level": "Level",
      "edit": "Edit",
      "configure": "Configure"
    },
    "abilities": {
      "method": "Method",
      "standardArray": "Standard Array",
      "pointBuy": "Point Buy",
      "roll": "Roll",
      "rollAbilities": "Roll Abilities",
      "available": "Available:",
      "standardArrayDesc": "Assign 15, 14, 13, 12, 10, 8 to your abilities. Each value can only be used once.",
      "pointBuyDesc": "Spend {{total}} points. All abilities start at 8. Higher scores cost more.",
      "rollingDesc": "Roll 4d6, drop the lowest die for each ability. Click Roll to generate scores, then assign them.",
      "pointsRemaining": "Points remaining: {{remaining}} / {{total}}",
      "assigned": "{{value}} (assigned)"
    },
    "details": {
      "description": "Add optional details about your character's appearance, personality, and backstory.",
      "portraitUrl": "Portrait URL (Optional)",
      "portraitPlaceholder": "https://example.com/portrait.jpg",
      "portraitAlt": "Character portrait",
      "alignment": "Alignment (Optional)",
      "selectAlignment": "Select alignment...",
      "physicalCharacteristics": "Physical Characteristics (Optional)",
      "age": "Age",
      "agePlaceholder": "e.g., 25",
      "height": "Height",
      "heightPlaceholder": "e.g., 5'10\"",
      "weight": "Weight",
      "weightPlaceholder": "e.g., 170 lbs",
      "eyes": "Eyes",
      "eyesPlaceholder": "e.g., Blue",
      "hair": "Hair",
      "hairPlaceholder": "e.g., Brown, long",
      "skin": "Skin",
      "skinPlaceholder": "e.g., Fair",
      "backstory": "Description & Backstory (Optional)",
      "backstoryPlaceholder": "Describe your character's appearance, personality, backstory...",
      "alliesOrganizations": "Allies & Organizations (Optional)",
      "alliesPlaceholder": "Notable allies, faction affiliations, organizations..."
    },
    "equipment": {
      "method": "Equipment Method",
      "packs": "Equipment Packs",
      "gold": "Starting Gold",
      "packsDesc": "Choose from your class's starting equipment options.",
      "goldDesc": "Roll for gold and purchase your own equipment.",
      "guaranteed": "Guaranteed Equipment",
      "choices": "Equipment Choices",
      "noChoices": "No equipment choices to make.",
      "startingGold": "Starting Gold",
      "goldLabel": "{{className}}: {{diceNotation}} gp",
      "goldAmount": "{{gold}} gp",
      "reroll": "Reroll",
      "rollGold": "Roll {{diceNotation}}",
      "goldPurchaseDesc": "You have {{gold}} gold pieces to purchase equipment. Consult the Player's Handbook for equipment prices, or work with your DM.",
      "goldRollDesc": "Roll for starting gold, then use the result to purchase equipment from the Player's Handbook.",
      "goldUnavailable": "Starting gold information not available for your class.",
      "noClasses": "No classes selected. Go back to select at least one class."
    },
    "review": {
      "unknownRace": "Unknown Race",
      "noClass": "No Class",
      "noBackground": "No Background",
      "savingThrows": "Saving Throws",
      "skills": "Skills",
      "proficiencies": "Proficiencies",
      "racialTraits": "Racial Traits",
      "classFeatures": "Class Features",
      "backgroundFeature": "Background Feature",
      "spellcasting": "Spellcasting",
      "equipment": "Equipment",
      "personality": "Personality",
      "noEquipment": "No equipment selected",
      "characterDetails": "Character Details",
      "alignment": "Alignment:",
      "age": "Age: ",
      "height": "Height: ",
      "weight": "Weight: ",
      "eyes": "Eyes: ",
      "hair": "Hair: ",
      "skin": "Skin: ",
      "descriptionLabel": "Description:",
      "alliesOrganizationsLabel": "Allies & Organizations:",
      "ac": "AC",
      "unarmored": "Unarmored",
      "hp": "HP",
      "initiative": "Initiative",
      "speed": "Speed",
      "prof": "Prof",
      "traits": "Traits: ",
      "ideal": "Ideal: ",
      "bond": "Bond: ",
      "flaw": "Flaw: ",
      "tabStatistics": "Statistics",
      "tabFeatures": "Features",
      "tabCharacter": "Character",
      "spells": "{{className}} Spells",
      "level": "Level {{level}}"
    }
  },
  "diceRoller": {
    "quickRoll": "Quick Roll",
    "customRoll": "Custom Roll",
    "placeholder": "2d6+5",
    "roll": "Roll",
    "invalidFormat": "Invalid format. Try: 2d6+5, d20, 3d8-2",
    "emptyState": "Roll some dice!"
  },
  "validation": {
    "characterName": "Character name",
    "raceSelection": "Race selection",
    "subraceSelection": "Subrace selection",
    "backgroundSelection": "Background selection",
    "personalityTraits": "Personality traits ({{count}}/2)",
    "idealSelection": "Ideal selection",
    "bondSelection": "Bond selection",
    "flawSelection": "Flaw selection",
    "atLeastOneClass": "At least one class",
    "classSubclass": "{{className}} subclass",
    "skillProficiencies": "{{className}} skill proficiencies ({{selected}}/{{required}})",
    "cantrips": "{{className}} cantrips ({{count}}/{{max}})",
    "spells": "{{className}} spells ({{count}}/{{max}})",
    "abilityScores": "Ability scores ({{missing}} remaining)",
    "equipmentChoice": "{{className}} equipment choice {{index}}",
    "rollStartingGold": "Roll for starting gold",
    "racialAbilityBonuses": "Racial ability bonuses ({{selected}}/{{required}})",
    "racialLanguageSelection": "Racial language selection ({{selected}}/{{required}})"
  },
  "characterSheet": {
    "combat": "Combat",
    "spells": "Spells",
    "abilities": "Abilities",
    "character": "Character",
    "equipment": "Equipment",
    "hp": "HP",
    "tempHP": "Temp HP",
    "ac": "AC",
    "initiative": "Initiative",
    "speed": "Speed",
    "profBonus": "Prof Bonus",
    "hitDice": "Hit Dice",
    "deathSaves": "Death Saves",
    "attacks": "Attacks",
    "shortRest": "Short Rest",
    "longRest": "Long Rest",
    "damage": "Damage",
    "heal": "Heal",
    "spellSlots": "Spell Slots",
    "concentration": "Concentration",
    "savingThrows": "Saving Throws",
    "skillChecks": "Skill Checks",
    "features": "Features",
    "proficiencies": "Proficiencies",
    "languages": "Languages",
    "personalityTraits": "Personality Traits",
    "ideal": "Ideal",
    "bond": "Bond",
    "flaw": "Flaw",
    "currency": "Currency",
    "inventory": "Inventory",
    "attunement": "Attunement",
    "encumbrance": "Encumbrance",
    "restConfirmTitle": "Confirm {{restType}} Rest",
    "shortRestDesc": "A short rest is a period of downtime, at least 1 hour long. You can spend Hit Dice to recover HP.",
    "longRestDesc": "A long rest is an extended period of downtime, at least 8 hours long. You regain all HP and recover half your Hit Dice (minimum 1). Spell slots are restored.",
    "confirm": "Confirm",
    "cancel": "Cancel"
  },
  "common": {
    "search": "Search",
    "close": "Close",
    "save": "Save",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "warning": "Warning",
    "info": "Info"
  }
}
